import { render } from "./client.vue?vue&type=template&id=7236283c&scoped=true&ts=true"
import script from "./client.vue?vue&type=script&lang=ts&config=true"
export * from "./client.vue?vue&type=script&lang=ts&config=true"

import "./client.vue?vue&type=style&index=0&id=7236283c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7236283c"]])

export default __exports__